import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import { enumUtil } from '../../../../utils/Enum';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import FormValidator from '../../../../utils/FormValidator';
import NotificationHandler from '../../../../utils/NotificationHandler';
import isNull from '../../../../utils/NullChecking';
import { ServerRequestProtected } from '../../../../utils/ServerDataRequest';
import { Modal } from "react-bootstrap";
import ModalHeader from '../../../Setup/Shared/ModalHeader';
import DatePicker from '../../../General/DatePicker';
import handleNumericCheck from '../../../../utils/HandleNumericKeys';
import Loader from '../../../shared/Loader/Loader';
import handleDecimalCheck from '../../../../utils/handleDecimalCheck';
import { FindFirstChild } from '../../../../utils/FindMenuOption';
import ModalFooter from '../../../Setup/Shared/ModalFooter';
const CollectCopay = (props) => {
    let { isOpenCopay, OnCloseCopay, PatientID, type, ID } = { ...props }
    let IsEditAllowed = FindFirstChild('Patient', 'Payments')?.IsAdd

    const Copay = () => {
        return <p style={{ color: '#434343', fontFamily: 'Poppins', fontWeight: '600', margin: '0', fontSize: '14px', fontWeight: '600', }}>Add Advance Payment </p>;
    };


    let Cash_Modal = {
        CopayDue: 'true',
        // Comments: '',
        // DateCollected: null,
        PaymentMethod: '',
    }
    let Check_Modal = {
        CopayDue: 'true',
        Check: '',
        CheckAmount: '',
        // Comments: '',
        // DateCollected: null,
        PaymentMethod: '',
    }
    let Other_Modal = {
        CopayDue: 'true',
        OtherPaymentMethod: '',
        // Comments: '',
        // DateCollected: null,
        PaymentMethod: '',
    }
    let Credit_Modal = {
        CopayDue: 'true',
        CreditCard: '',
        Last4Digit: '',
        // Comments: '',
        // DateCollected: null,
        PaymentMethod: '',
    }
    let Pateint_Modal = {
        PatientName: '',
        LastName: '',
        Age: '',
        Gender: '',
        Providers: '',
        FollowUpVisit: '',
        Copay: ''
    }
    const API_URL = enumUtil.controller.Claim
    const API_URL_Payment = enumUtil.controller.PatientPayment
    const [patientID, setPatientID] = useState('')
    const [mainCash, setmainCash] = useState(Cash_Modal)
    const [saveUpdatedCash, setsaveUpdatedCash] = useState({})
    const [mainCheck, setmainCheck] = useState(Check_Modal)
    const [saveUpdatedCheck, setsaveUpdatedCheck] = useState({})
    const [mainOther, setmainOther] = useState(Other_Modal)
    const [saveUpdatedOther, setsaveUpdatedOther] = useState({})
    const [mainCredit, setmainCredit] = useState(Credit_Modal)
    const [saveUpdatedCredit, setsaveUpdatedCredit] = useState({})
    const [mainPtCredit, setmainPtCredit] = useState(Check_Modal)
    const [saveUpdatedPtCredit, setsaveUpdatedPtCredit] = useState({})
    const [mainPateintModal, setmainPatientModal] = useState(Pateint_Modal)
    const [paymentMethod, setpaymentMethod] = useState('')
    const [mainCopayPaymentSave, setmainCopayPaymentSave] = useState({})
    const [DateCollected, setDateCollected] = useState(null)
    const [Comments, setComments] = useState('')
    const [isDateGreater, setisDateGreater] = useState('')
    const [PatientName, setPatientName] = useState('')
    const [patientBody, setPatientBody] = useState({ "TableName": "", "SearchParam": '' })
    const [isPateintAvailable, setisPateintAvailable] = useState(false)
    const [is, setIs] = useState(false);
    const [isLoading, setIsLoading] = useState(false)
    const [isCopayAlreadyPaid, setisCopayAlreadyPaid] = useState(false);
    const [CollectedAmount, setCollectedAmount] = useState("")
    let ClaimIDR = useSelector(state => state.Open_Claim_Tab.find((pt) => pt.active === true));
    if (ClaimIDR && ClaimIDR.data) {
        ClaimIDR = ClaimIDR.data.id;
    }

    let valModal = {}
    let ValidationModal = {
        DateCollectedVal: '',
        CollectedAmountVal: '',
    }
    const [validation, setValidation] = useState({ ValidationModal })
    const CopayValidation = async () => {
        let ValidationModal = {
            DateCollectedVal: FormValidator(
                DateCollected,
                enumUtil.enumValidationType.Required,
                'Date ',
            ),
            CollectedAmountVal: FormValidator(
                CollectedAmount,
                enumUtil.enumValidationType.Required,
                'Amount ',
            ),
        }
        await setValidation(ValidationModal)
        valModal = ValidationModal

    }
    const PatientPaymentValidationCheck = async () => {
        let ValidationModal = {
            CheckVal: FormValidator(
                mainCheck.Check,
                enumUtil.enumValidationType.Required,
                'Check # ',
            ), DateCollectedVal: FormValidator(
                DateCollected,
                enumUtil.enumValidationType.Required,
                'Date ',
            ),
            CollectedAmountVal: FormValidator(
                CollectedAmount,
                enumUtil.enumValidationType.Required,
                'Amount ',
            )
        }
        await setValidation(ValidationModal)
        valModal = ValidationModal
    }
    const PatientPaymentValidationCredit = async () => {
        let ValidationModal = {
            CreditVal: FormValidator(
                mainCredit.CreditCard,
                enumUtil.enumValidationType.Required,
                'CreditCard ',
            ), DateCollectedVal: FormValidator(
                DateCollected,
                enumUtil.enumValidationType.Required,
                'Date ',
            ),
            CollectedAmountVal: FormValidator(
                CollectedAmount,
                enumUtil.enumValidationType.Required,
                'Amount ',
            )
        }
        await setValidation(ValidationModal)
        valModal = ValidationModal

    }
    const handleChangeAmount = (e) => {
        setCollectedAmount(e.target.value)
    }
    const handleChangePatientPayment = (e, type) => {
        let { name, value } = e.target
        if (type === 'cash') {
            let modal = { ...mainCash }
            let saveModal = { ...saveUpdatedCash }
            if (name === 'CopayDue') {
                modal[name] = !modal[name]
            } else {
                modal[name] = value
            }
            setmainCash(modal)
            for (var property in Cash_Modal) {
                if (name === property) {
                    if (name === 'CopayDue') {
                        saveModal[name] = modal[name] + ""
                    } else {
                        saveModal[name] = value
                    }
                }
            }
            setsaveUpdatedCash(saveModal)
        } else if (type === 'check') {
            let modal = { ...mainCheck }
            let saveModal = { ...saveUpdatedCheck }
            if (name === 'CopayDue') {
                modal[name] = !modal[name]
            } else {
                modal[name] = value
            }
            setmainCheck(modal)
            for (var property in Check_Modal) {
                if (name === property) {
                    if (name === 'CopayDue') {
                        saveModal[name] = modal[name] + ""
                    } else {
                        saveModal[name] = value
                    }
                }
            }
            setsaveUpdatedCheck(saveModal)
        } else if (type === 'credit') {
            let modal = { ...mainCredit }
            let saveModal = { ...saveUpdatedCredit }
            if (name === 'CopayDue') {
                modal[name] = !modal[name]
            } else {
                modal[name] = value
            }
            setmainCredit(modal)
            for (var property in Credit_Modal) {
                if (name === property) {
                    if (name === 'CopayDue') {
                        saveModal[name] = modal[name] + ""
                    } else {
                        saveModal[name] = value
                    }
                }
            }
            setsaveUpdatedCredit(saveModal)
        } else if (type === 'other') {
            let modal = { ...mainOther }
            let saveModal = { ...saveUpdatedOther }
            if (name === 'CopayDue') {
                modal[name] = !modal[name]
            } else {
                modal[name] = value
            }
            setmainOther(modal)
            for (var property in Other_Modal) {
                if (name === property) {
                    if (name === 'CopayDue') {
                        saveModal[name] = modal[name] + ""
                    } else {
                        saveModal[name] = value
                    }
                }
            }
            setsaveUpdatedOther(saveModal)
        }
    }
    const handleSaveCopay = async () => {
        let AmountValidation = false
        let ZeroCopayMessage = ''
        // debugger
        if (mainPateintModal.Copay !== "") {
            if (CollectedAmount - "" > mainPateintModal.Copay - "") {
                AmountValidation = true
                ZeroCopayMessage = 'Collected amount cannot be greater than Copay'
            } else if (mainPateintModal.Copay === 0) {
                AmountValidation = true
                ZeroCopayMessage = "Cannot save when copay amount is zero/0"
            }
        }
        await CopayValidation()
        if (paymentMethod === 'Credit') {
            await PatientPaymentValidationCredit()
        } else if (paymentMethod === 'Check') {
            await PatientPaymentValidationCheck()
        }


        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation || !isNull(isDateGreater)) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else if (AmountValidation === true) {
            NotificationHandler(ZeroCopayMessage, enumUtil.enumtoaster.error)
        } else {
            let SaveModal
            if (paymentMethod === 'Cash') {
                SaveModal = { ...saveUpdatedCash, CollectedDate: DateCollected, CollectedAmount: CollectedAmount, Comments: Comments, PaymentMethod: paymentMethod }
            } else if (paymentMethod === 'Check') {
                SaveModal = { ...saveUpdatedCheck, CollectedDate: DateCollected, CollectedAmount: CollectedAmount, Comments: Comments, PaymentMethod: paymentMethod }
            } else if (paymentMethod === 'Credit') {
                SaveModal = { ...saveUpdatedCredit, CollectedDate: DateCollected, CollectedAmount: CollectedAmount, Comments: Comments, PaymentMethod: paymentMethod }
            } else if (paymentMethod === 'Other') {
                SaveModal = { ...saveUpdatedOther, CollectedDate: DateCollected, CollectedAmount: CollectedAmount, Comments: Comments, PaymentMethod: paymentMethod }
            } else {
                SaveModal = { ...saveUpdatedCash, CollectedDate: DateCollected, CollectedAmount: CollectedAmount, Comments: Comments, PaymentMethod: 'Cash' }
            }

            SaveModal['PaymentType'] = 'Advance Payment';
            SaveModal['PatientID'] = PatientID + ""
            let saveModal = {
                TableName: enumUtil.enumAPITableName.CollectCopay,
                ID: 0,
                data: SaveModal,
                value: null
            }
            setIsLoading(true)
            ServerRequestProtected(API_URL_Payment + "/CollectCopay", 'post', saveModal).then((response) => {
                if (!isNull(response.id)) {
                    setIsLoading(false)
                    NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
                    OnCloseCopay('AdvancePayment')
                }
            }).catch((error) => {
                setIsLoading(false)
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
            })
        }
    }
    const handleChangeLink = (type) => {
        setpaymentMethod(type)
    }
    const handleSelectedData = (selectedData, name, type) => {
        if (name === 'PatientID' && !isNull(selectedData)) {
            if (selectedData.value != -1) {
                setPatientID(selectedData.value + "")
                setPatientName(selectedData.display)
            } else {
                setPatientID("")
                setPatientName("")
            }
        }
    }
    const handlePateintChange = (e) => {
        setIs(false);
        let { name, value } = e.target;
        setPatientName(value);
        setPatientBody({ "TableName": enumUtil.enumAPITableName.Patient, "SearchParam": value })
    }
    const handleCalendarChange = (date, type) => {
        if (date > new Date()) {
            setisDateGreater(<div className="invalid-feedback" style={{ display: "block" }}>Date cannot be greater than current date</div>)
        } else {
            setisDateGreater('')
            var FormatedDate = date
            setDateCollected(FormatedDate)
        }

    }
    const handleCopayPaid = () => {
        OnCloseCopay()
        setisCopayAlreadyPaid(false)
    }
    return (
        <>
            <Modal show={isOpenCopay} onHide={isOpenCopay} backdrop="static" keyboard={false} centered dialogClassName="app-modal hk-modal-v1 add_block_appointment ar-advance-payment-popup">
                {isLoading ? <Loader /> : null}
                <Modal.Body>
                    {/* <ModalHeader HeaderName={Copay} DeletePopup={""} isClosed={OnCloseCopay} key={111} Name={'Copay'} /> */}
                    <div className="d-flex align-items-center justify-content-between mb-3 px-10">
                        <p className="heading dark-clr fs-14">Add Advance Payment</p>
                        <i class="icon-x-cros fs-20 dark-clr" onClick={OnCloseCopay}></i>
                    </div>
                    <div className='inside_body'>
                        <div className="mb-1 d-flex gap-10 align-items-center">
                            <div className={`input mb-0 ${isDateGreater ? isDateGreater : validation.DateCollectedVal ? validation.DateCollectedVal ? 'error' : '' : ''}`}>
                                <DatePicker
                                    label={<span className=''>Collected Date <span className="req">*</span></span>}
                                    value={DateCollected}
                                    maxDate={new Date()}
                                    handleCalendarChangefunc={date => handleCalendarChange(date)}
                                    inputError={!isNull(validation.DateCollectedVal) ? true : false}
                                />
                                <span>{isDateGreater ? isDateGreater : validation.DateCollectedVal ? validation.DateCollectedVal : null}</span>
                            </div>
                            <div className={validation.CollectedAmountVal ? "input error" : "input"}>
                                <label className="pb-3px">Collected Amount <span className="req">*</span></label>
                                <input
                                    type="text"
                                    className="form-control "
                                    placeholder="Collected Amount"
                                    name="CollectedAmount"
                                    id="CollectedAmount"
                                    value={CollectedAmount}
                                    onKeyPress={(event) => handleDecimalCheck(event)}
                                    onChange={(e) => handleChangeAmount(e)}
                                />
                                {validation.CollectedAmountVal}
                            </div>
                        </div>
                        <div className="row patient_payment_tabs mt-2">
                            <span className="text ar-light-color">Payment Method</span>
                            <Tab.Container defaultActiveKey="cash">
                                <div className='ms-0'>
                                    <Nav variant="tabs" className="d-flex border-0 gx-0 mt-1">
                                        <Nav.Item className="ar-copay-link ar-pad" onClick={() => handleChangeLink('Cash')}>
                                            <Nav.Link eventKey="cash" className="text">Cash</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item className="ar-copay-link ar-pad" onClick={() => handleChangeLink('Check')}>
                                            <Nav.Link eventKey="check" className="text">Check</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item className="ar-copay-link ar-pad" onClick={() => handleChangeLink('Credit')}>
                                            <Nav.Link eventKey="credit" className="text">Credit</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item className="ar-copay-link ar-pad" onClick={() => handleChangeLink('Other')}>
                                            <Nav.Link eventKey="other" className="text">Other</Nav.Link>
                                        </Nav.Item>
                                        {/* <Nav.Item className="ar-copay-link ar-pad" onClick={() => handleChangeLink('PatientCredit')}>
                                            <Nav.Link eventKey="ptcredit" className="text ">Patient Credit</Nav.Link>
                                        </Nav.Item> */}
                                    </Nav>
                                </div>
                                <Tab.Content className=''>
                                    <Tab.Pane eventKey='cash'>
                                        <div className="cash-tab">
                                            <div className=" row mt-2 gx-0 align-items-center">
                                                {/* <div className="col-5 d-flex custom_check_box ">
                                                    <input
                                                        type="checkbox"
                                                        name="CopayDue"
                                                        className='form-check-input p-0'
                                                        id="CopayDueCash"
                                                        checked={mainCash.CopayDue}
                                                        onChange={(e) => handleChangePatientPayment(e, 'cash')}
                                                    />
                                                    <span className="text ar-light-color ms-2" for='CopayDueCash'>Copay Due</span>
                                                </div>
                                                <div className="col-3">
                                                    <p className="text ar-light-color mt-2 ">{!isNull(mainPateintModal.Copay) ? '$' + mainPateintModal.Copay : 'N/A'}</p>
                                                </div> */}
                                                {/* <div className="col-4">

                                                </div> */}
                                            </div>
                                            {/* <div className=" row mt-2 ">
                                        <div className="col-5">
                                            <input type="checkbox" name="coPay" id="coPay" />
                                            <span className="text ar-light-color ms-2 ">Previous Balance</span>
                                        </div>
                                        <div className="col-7 d-flex gap-5">
                                            <p className="text mt-2 ar-light-color ">$100</p>
                                            <input type="text" className="form-control  rounded w-75 mt-1 " name="ClaimID" id="ClaimID" value="" />
                                        </div>
                                    </div> */}
                                        </div>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey='check' >
                                        <div className="check-tab">
                                            {/* <div className="row mt-2 align-items-center">
                                                <div className="col-5 custom_check_box d-flex ">
                                                    <input
                                                        type="checkbox"
                                                        name="CopayDue"
                                                        className='form-check-input'
                                                        id="CopayDueCheck"
                                                        checked={mainCheck.CopayDue}
                                                        onChange={(e) => handleChangePatientPayment(e, 'check')}
                                                    />
                                                    <span className="text ar-light-color ms-2 ">Copay Due</span>
                                                </div>
                                                <div className="col-7 d-flex gap-5">
                                                    <p className="text ar-light-color mt-2 ">{!isNull(mainPateintModal.Copay) ? '$' + mainPateintModal.Copay : 'N/A'}</p>
                                                    <input
                                                        type="text"
                                                        className="form-control  rounded w-75 mt-1"
                                                        placeholder="Collected Amount"
                                                        name="CollectedAmount"
                                                        id="CollectedAmount"
                                                        value={CollectedAmount}
                                                        onKeyPress={(event) => handleNumericCheck(event)}
                                                        onChange={(e) => handleChangeAmount(e)}
                                                    />
                                                </div>
                                            </div> */}
                                            {/* <div className=" row mt-2 ">
                                        <div className="col-5">
                                            <input type="checkbox" name="coPay" id="coPay" />
                                            <span className="text ar-light-color ms-2 ">Previous Balance</span>
                                        </div>
                                        <div className="col-7 d-flex gap-5">
                                            <p className="text mt-2 ar-light-color ">$100</p>
                                            <input type="text" className="form-control  rounded w-75 mt-1 " name="ClaimID" id="ClaimID" value="" />
                                        </div>
                                    </div> */}
                                            <div className="row align-items-baseline" >
                                                <div className="col-6">
                                                    <div className={validation.CheckVal ? 'input error' : 'input'}>
                                                        <label htmlFor="chk" className="text ar-light-color">Check # <span className='req'>*</span></label>
                                                        <input
                                                            type="text"
                                                            name="Check"
                                                            id="Check"
                                                            className='form-control'
                                                            value={mainCheck.Check}
                                                            onChange={(e) => handleChangePatientPayment(e, 'check')}
                                                        />
                                                        {validation.CheckVal}
                                                    </div>

                                                </div>
                                                <div className="col-6">
                                                    <label htmlFor="chk1" className="text ar-light-color">Check Amount</label>
                                                    <input
                                                        type="text"
                                                        name="CheckAmount"
                                                        id="CheckAmount"
                                                        className="form-control  rounded"
                                                        value={mainCheck.CheckAmount}
                                                        onKeyPress={(event) => handleNumericCheck(event)}
                                                        onChange={(e) => handleChangePatientPayment(e, 'check')}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey='credit' >
                                        <div className="credit-tab">
                                            {/* <div className=" row mt-2 align-items-center">
                                                <div className="col-5 custom_check_box d-flex">
                                                    <input
                                                        type="checkbox"
                                                        className='form-check-input'
                                                        name="CopayDue"
                                                        id="CopayDueCredit"
                                                        checked={mainCredit.CopayDue}
                                                        onChange={(e) => handleChangePatientPayment(e, 'credit')}
                                                    />
                                                    <span className="text ar-light-color ms-2 ">Copay Due</span>
                                                </div>
                                                <div className="col-7 d-flex gap-5">
                                                    <p className="text ar-light-color mt-2 ">{!isNull(mainPateintModal.Copay) ? '$' + mainPateintModal.Copay : 'N/A'}</p>
                                                    <input
                                                        type="text"
                                                        className="form-control  rounded w-75 mt-1"
                                                        placeholder="Collected Amount"
                                                        name="CollectedAmount"
                                                        id="CollectedAmount"
                                                        value={CollectedAmount}
                                                        onKeyPress={(event) => handleNumericCheck(event)}
                                                        onChange={(e) => handleChangeAmount(e)}
                                                    />
                                                </div>
                                            </div> */}
                                            {/* <div className=" row mt-2 ">
                                        <div className="col-5">
                                            <input type="checkbox" name="coPay" id="coPay" />
                                            <span className="text ar-light-color ms-2 ">Previous Balance</span>
                                        </div>
                                        <div className="col-7 d-flex gap-5">
                                            <p className="text mt-2 ar-light-color ">$100</p>
                                            <input type="text" className="form-control  rounded w-75 mt-1 " name="ClaimID" id="ClaimID" value="" />
                                        </div>
                                    </div> */}
                                            <div className=" row align-items-center " >
                                                <div class="col-5">
                                                    <div className={validation.CreditVal ? 'input error' : 'input'}>
                                                        <label for="creditCard" className="text ar-light-color ps-1" >Credit Card <span className='req'>*</span></label>
                                                        <input
                                                            type="text"
                                                            className='form-control'
                                                            name="CreditCard"
                                                            id="CreditCard"
                                                            value={mainCredit.CreditCard}
                                                            onChange={(e) => handleChangePatientPayment(e, 'credit')}
                                                        />
                                                        {validation.CreditVal}
                                                    </div>
                                                </div>
                                                <div className="col-7">
                                                    <label htmlFor="Last4Digit" className="text ar-light-color">Last 4-Digits of Card</label>
                                                    <div className="d-flex align-items-center">
                                                        <label className="col-6 text ar-light-color fs-10"> XXXX-XXXX-XXXX-</label>
                                                        <input
                                                            type="text"
                                                            name="Last4Digit"
                                                            id="Last4Digit"
                                                            className="col-5 form-control  rounded w-50"
                                                            value={mainCredit.Last4Digit}
                                                            onKeyPress={(event) => handleNumericCheck(event)}
                                                            onChange={(e) => handleChangePatientPayment(e, 'credit')}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Tab.Pane>

                                    <Tab.Pane eventKey='other' >
                                        <div className="other-tab">
                                            {/* <div className="row mt-2 align-items-center">
                                                <div className="col-5 custom_check_box d-flex">
                                                    <input
                                                        type="checkbox"
                                                        name="CopayDue"
                                                        className='form-check-input'
                                                        id="CopayDueOther"
                                                        checked={mainOther.CopayDue}
                                                        onChange={(e) => handleChangePatientPayment(e, 'other')}
                                                    />
                                                    <span className="text ar-light-color ms-2 ">Copay Due</span>
                                                </div>
                                                <div className="col-7 d-flex gap-5">
                                                    <p className="text ar-light-color mt-2 ">{!isNull(mainPateintModal.Copay) ? '$' + mainPateintModal.Copay : 'N/A'}</p>
                                                    <input
                                                        type="text"
                                                        className="form-control  rounded w-75 mt-1"
                                                        placeholder="Collected Amount"
                                                        name="CollectedAmount"
                                                        id="CollectedAmount"
                                                        value={CollectedAmount}
                                                        onKeyPress={(event) => handleNumericCheck(event)}
                                                        onChange={(e) => handleChangeAmount(e)}
                                                    />
                                                </div>
                                            </div> */}
                                            {/* <div className=" row mt-2 ">
                                        <div className="col-5">
                                            <input type="checkbox" name="coPay" id="coPay" />
                                            <span className="text ar-light-color ms-2 ">Previous Balance</span>
                                        </div>
                                        <div className="col-7 d-flex gap-5">
                                            <p className="text mt-2 ar-light-color ">$100</p>
                                            <input type="text" className="form-control  rounded w-75 mt-1 " name="ClaimID" id="ClaimID" value="" />
                                        </div>
                                    </div> */}
                                            <div>
                                                <div>
                                                    <label htmlFor="chk" className="text ar-light-color">Other Payment Method</label>
                                                    <input
                                                        type="text"
                                                        name="OtherPaymentMethod"
                                                        id="OtherPaymentMethod"
                                                        className="form-control  rounded w-50 text"
                                                        value={mainOther.OtherPaymentMethod}
                                                        onChange={(e) => handleChangePatientPayment(e, 'other')}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                    </Tab.Pane>
                                </Tab.Content>
                            </Tab.Container>
                            <div className='d-flex flex-column'>
                                <label htmlFor="cmnt" className="text mb-1 ar-light-color">Comments</label>
                                <textarea name="cmnt" id="cmnt" rows="3" className="ar-texteara text w-100" value={Comments} onChange={(e) => setComments(e.target.value)}></textarea>
                            </div>
                        </div>
                    </div>
                    {/* <div className="app_border border-bottom-0 border-end-0 border-start-0 mt-2">
                        <div className="btns-group text-end pt-2 d-flex  align-items-center justify-content-end">
                            <div>
                                <button className="btn btn-light h-auto no-width p-0 px-3 py-1 text me-1" onClick={OnCloseCopay}>Cancel</button>
                                <button className="btn btn-orange h-auto no-width p-0 px-3 py-1 text_clr text" onClick={handleSaveCopay}>Save</button>
                            </div>
                        </div>
                    </div> */}
                </Modal.Body>
                <ModalFooter isSaved={OnCloseCopay} handleSave={handleSaveCopay} key={214} Name={'handleSaveCopay'} UpdatedDate={''} UpdatedBy={''} ID={''} IsEditAllowed={IsEditAllowed} />

                {/* <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-end gap-2 ar_footer">
                    <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={OnCloseCopay}>Cancel</button>
                    <button className={IsEditAllowed ? "btn btn-validate px-10 h-100" : "btn btn-validate px-10 h-100 disabled"} onClick={handleSaveCopay}>Save</button>
                </div> */}
            </Modal>
            <Modal show={isCopayAlreadyPaid} onHide={isCopayAlreadyPaid} backdrop="static" keyboard={false} centered dialogClassName="app-modal paid_copay hk-modal-v1">
                <div className='ar-header d-flex justify-content-between'>
                    <p className='text'>Attention Please</p>
                    <i className='icon-Icon-metro-cross cursor-pointer' onClick={handleCopayPaid}></i>
                </div>
                <div className='ar-content d-flex justify-content-center'>
                    <p className='text d-flex align-items-center'> <i className='icon-Vector3 fs-18'></i> Copay is already Paid</p>
                </div>
                <div className='br-top-1 ar-border-color'>
                    <div className='ar-footer d-flex justify-content-center align-items-center' onClick={handleCopayPaid}>
                        <p className='text text-white'>OK</p>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default CollectCopay